export const condicionesIva = [
  {
    id: 1,
    nombre: "IVA Responsable Inscripto",
  },
  {
    id: 2,
    nombre: "IVA Responsable no Inscripto",
  },
  {
    id: 3,
    nombre: "IVA No Responsable",
  },
  {
    id: 4,
    nombre: "IVA Sujeto Exento",
  },
  {
    id: 5,
    nombre: "Consumidor Final",
  },
  {
    id: 6,
    nombre: "Responsable Monotributo",
  },
  {
    id: 7,
    nombre: "Sujeto No Categorizado",
  },
  {
    id: 8,
    nombre: "Proveedor del Exterior",
  },
  {
    id: 9,
    nombre: "Cliente del Exterior",
  },
  {
    id: 10,
    nombre: "IVA Liberado – Ley Nº 19.640",
  },
  {
    id: 11,
    nombre: "IVA Responsable Inscripto – Agente de Percepción",
  },
  {
    id: 12,
    nombre: "Pequeño Contribuyente Eventual",
  },
  {
    id: 13,
    nombre: "Monotributista Social",
  },
  {
    id: 14,
    nombre: "Pequeño Contribuyente Eventual Social",
  },
  {
    id: 15,
    nombre: "Consumidor Final V",
  },
];

export const TIPO_FACTURAS = [
  // {
  //   value: "A",
  //   label: "Factura A",
  //   condicionIVA: [1, 11],
  // },
  // {
  //   value: "B",
  //   label: "Factura B",
  //   condicionIVA: [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15],
  // },
  // {
  //   value: "V",
  //   label: "Factura V",
  //   condicionIVA: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15],
  // },
  {
    value: "B",
    label: "Factura B",
  },
];
